const { BASE_URL } = require("./client");

const GET_ALL_DETAILS = BASE_URL + "/startupshortsadmin";
const ADD_STARTUPSHORT = BASE_URL + "/startupshortsadmin/create";
const UPDATE_STARTUPSHORT = BASE_URL + "/startupshortsadmin/update/";
const DELETE_STARTUPSHORT = BASE_URL + "/startupshortsadmin/";
const DOWNLOAD_EXCEL_SHEET = BASE_URL + "/startupshortadmin/download";

export { GET_ALL_DETAILS, DELETE_STARTUPSHORT, DOWNLOAD_EXCEL_SHEET , ADD_STARTUPSHORT , UPDATE_STARTUPSHORT };